/* Champ code promo du tiroir de panier.
   Shopify n'expose PAS les codes de reduction a l'API panier (/cart/update.js
   ne les prend pas). La seule voie officielle depuis la vitrine est la route
   /discount/<code>, qui pose le code sur la session puis redirige. On la
   sollicite en fetch, puis on RELIT le panier : /discount repond 200 meme sur
   un code invalide, la reponse HTTP ne prouve donc rien.

   ⚠ On ne peut PAS se contenter de "le panier a-t-il une remise ?" : si une
   remise est deja posee et que la cliente tape un code bidon, l'ancienne reste
   (verifie en reel) et on annoncerait un succes a tort. On compare donc le
   TITRE de la remise appliquee au code saisi. */
class MayloweDiscount extends HTMLElement {
  connectedCallback() {
    if (this.pret) return;
    this.pret = true;
    this.champ = this.querySelector('.maylowe-discount__input');
    this.bouton = this.querySelector('.maylowe-discount__submit');
    this.mot = this.querySelector('.maylowe-discount__message');
    if (!this.champ || !this.bouton) return;
    this.bouton.addEventListener('click', () => this.appliquer());
    this.champ.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); this.appliquer(); }
    });
  }

  get racine() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  dire(texte, erreur) {
    if (!this.mot) return;
    this.mot.textContent = texte || '';
    this.mot.hidden = !texte;
    this.mot.classList.toggle('maylowe-discount__message--erreur', !!erreur);
  }

  async panier() {
    const r = await fetch(`${this.racine}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  /* tous les codes actuellement poses, au niveau panier ET au niveau ligne */
  static titres(panier) {
    const t = [];
    (panier.cart_level_discount_applications || []).forEach((d) => t.push(d.title));
    (panier.items || []).forEach((i) =>
      (i.line_level_discount_allocations || []).forEach((d) =>
        t.push(d.discount_application && d.discount_application.title)));
    return t.filter(Boolean).map((x) => String(x).trim().toUpperCase());
  }

  async appliquer() {
    const code = (this.champ.value || '').trim();
    if (!code) { this.champ.focus(); return; }

    this.bouton.disabled = true;
    this.dire('', false);

    try {
      const avant = await this.panier();
      if (!avant.item_count) { this.dire('Your cart is empty.', true); return; }

      await fetch(`${this.racine}discount/${encodeURIComponent(code)}`, {
        method: 'GET',
        headers: { Accept: 'text/html' },
      });

      const apres = await this.panier();
      const pose = MayloweDiscount.titres(apres).includes(code.toUpperCase());

      if (!pose) {
        this.dire("That code isn't valid, or it doesn't apply to your cart.", true);
        return;
      }

      const gagne = (apres.total_discount || 0) - (avant.total_discount || 0);
      await this.redessiner(
        gagne > 0
          ? `${code.toUpperCase()} applied. You saved ${this.argent(gagne)}.`
          : `${code.toUpperCase()} applied.`
      );
    } catch (e) {
      this.dire('Something went wrong. Please try again.', true);
    } finally {
      this.bouton.disabled = false;
    }
  }

  argent(centimes) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
      }).format(centimes / 100);
    } catch (e) {
      return (centimes / 100).toFixed(2);
    }
  }

  /* On relit le tiroir cote serveur plutot que de recalculer les totaux en JS :
     le Liquid sait deja afficher la ligne de remise et le total remise. */
  async redessiner(message) {
    const html = await (await fetch(`${this.racine}?section_id=cart-drawer`)).text();
    const neuf = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    const actuel = document.querySelector('cart-drawer .drawer__inner');
    if (!neuf || !actuel) { this.dire(message, false); return; }

    actuel.innerHTML = neuf.innerHTML;
    const bloc = actuel.querySelector('maylowe-discount .maylowe-discount__message');
    if (bloc) { bloc.textContent = message; bloc.hidden = false; }
  }
}

if (!customElements.get('maylowe-discount')) {
  customElements.define('maylowe-discount', MayloweDiscount);
}
